export default __webpack_public_path__ + "static/RTG_PDP_LOGO_LA-Z-BOY_650x100-79884f8a888405cb39cea1353a3da294.png";